import React, { useState } from 'react'

import PalletPrint, { PalletPrintData } from './components/pallets/PalletPrint'
import { useDevanningState } from './stores/devanningStore'
import { usePalletActions, usePalletState } from './stores/palletStore'
import {
  useScanProgressActions,
  useScanProgressState
} from './stores/scanProgressStore'

import ConfirmDialog from '@/components/common/ConfirmDialog'
import { inboundV2Service } from '@/services'
import { useAuthStore } from '@/stores/authStore'
import { useUIStore } from '@/stores/useUIStore'

const PalletIndex: React.FC = () => {
  const { showSuccess, showError } = useUIStore()
  const { user } = useAuthStore()
  // 扫描
  const { masterBill } = useDevanningState()
  const { progress } = useScanProgressState()
  const { fetchProgress } = useScanProgressActions()
  // 打托
  const { palletModal, quickVisible } = usePalletState()
  const { closeQuickConfirm } = usePalletActions()
  // 打印
  const [showPrintDialog, setShowPrintDialog] = useState(false)
  const [printData, setPrintData] = useState<PalletPrintData>()

  const handleConfirmQuickPallet = async () => {
    if (masterBill && progress) {
      const { success, message, data } = await inboundV2Service.createPallet(
        masterBill.id,
        progress?.markId
      )
      if (success) {
        showSuccess(message)
        closeQuickConfirm()
        // 更新进度数据
        await fetchProgress(progress.markId)
        // 准备打印数据
        if (data?.palletCode) {
          setPrintData({
            customerNumber: masterBill?.customerNumber,
            houseBlNumber: data.houseBillNumber,
            devanDate: masterBill?.devanDate || '',
            palletCode: data.palletCode,
            total: data.cargoMarks[0].totalPackages,
            cargoMarks: data.cargoMarks,
            notes: '',
            printUser: user?.name || user?.nick || '名無し'
          })
          setShowPrintDialog(true)
        }
      } else {
        showError(message)
      }
    }
  }

  return (
    <>
      <ConfirmDialog
        isOpen={palletModal === 'quick' && quickVisible === true}
        title="🚛 快速打托确认(单Mark打托)"
        confirmText="确认打托"
        cancelText="取消"
        onConfirm={handleConfirmQuickPallet}
        onCancel={() => closeQuickConfirm()}
      >
        将为<span className="p-1 text-red-600">{progress?.markNumber}</span>
        (扫描数:
        <span className="p-1 text-blue-600">{progress?.summary.scanned}</span>)
        的已扫描货物创建托盘
      </ConfirmDialog>

      {printData && (
        <PalletPrint
          data={printData}
          visible={showPrintDialog}
          onClose={() => {
            setShowPrintDialog(false)
            setPrintData(undefined)
          }}
        />
      )}
    </>
  )
}

export default PalletIndex
